<footer class="footer">
    <div class="container text-center">
     
      <!-- <a class="cc-google-plus btn btn-link" href="#" target="_blank">
        <i class="fa fa-google-plus fa-2x" aria-hidden="true"></i>
      </a> -->
    </div>
    <div class="text-center text-muted">
      <p>&copy; All rights reserved.
      </p>
    </div>
  </footer>